import { render, staticRenderFns } from "./orgquadinfomodel.vue?vue&type=template&id=0c277342&scoped=true"
import script from "./orgquadinfomodel.vue?vue&type=script&lang=js"
export * from "./orgquadinfomodel.vue?vue&type=script&lang=js"
import style0 from "./orgquadinfomodel.vue?vue&type=style&index=0&id=0c277342&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c277342",
  null
  
)

export default component.exports